import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Icon, Label, Input } from '@iq/react-components';
import JSONEditor from '../../../JSONEditor';
import SelectPollingDateRange from '../../../SelectPollingDateRange';
import { schema, uiSchema } from './riskFiltersSchema';

const Filter = ({ filterFormData, setFilterFormData }) => {
  const ref = useRef(null);
  const [open, setOpen] = useState(false);
  const [unsavedFormData, setUnsavedFormData] = useState(filterFormData);

  const handleClickOutside = useCallback((event) => {
    if (
      ref.current &&
      !(
        ref.current.contains(event.target) ||
        // event toggles class (toggle svg icons' parents)
        event.target?.classList?.contains('show-events') ||
        event.target?.parentElement?.classList?.contains('show-events') ||
        // react-select menu option class matching
        Array.from(event.target.classList.values())
          .map((v) => v.match(/^css-\w{6}-option$/))
          .some((match) => !!match)
      )
    ) {
      setOpen(false);
    }
  }, []);
  useEffect(() => {
    if (open) {
      document.addEventListener('click', handleClickOutside, true);
    } else {
      document.removeEventListener('click', handleClickOutside, true);
    }
  }, [open]);

  const onFiltersApply = () => {
    setFilterFormData(unsavedFormData);
    setOpen(false);
  };
  const onFiltersReset = () => {
    setUnsavedFormData({
      riskLevels: {
        showLowRisk: true,
        showMediumRisk: true,
        showHighRisk: true,
      },
    });
  };

  const onFormChange = (e) => {
    setUnsavedFormData(e.formData);
  };

  return (
    <div
      ref={ref}
      className={`risk-filters-component`}
    >
      <div
        className="header"
        onClick={() => setOpen(!open)}
      >
        <div className="label">
          Filters{' '}
          {/* Commented out until other parts of identiq are ready for a "filters are currently active" icon

          {(!filterFormData.riskLevels.showLowRisk ||
            !filterFormData.riskLevels.showMediumRisk ||
            !filterFormData.riskLevels.showHighRisk) && (
            <svg
              height={14}
              width={6}
              className="active-filters-dot"
            >
              <circle
                r={3}
                cx="50%"
                cy="60%"
              />
            </svg>
          )} */}
        </div>
        <div className="icon-container">
          <Icon
            icon="he-down"
            size="xs"
          />
        </div>
      </div>
      {open && (
        <div className="content">
          <div className="actions">
            <Label>Filters</Label>
            <div className="actions-button">
              <Button
                onClick={onFiltersReset}
                activity="secondary"
                slim
              >
                Reset
              </Button>
              <Button
                slim
                onClick={onFiltersApply}
              >
                Apply
              </Button>
            </div>
          </div>

          <div className="body">
            <div className="risk">
              <div>
                <JSONEditor
                  formData={unsavedFormData}
                  scrollIntoView={false}
                  onFormChange={onFormChange}
                  schema={schema}
                  uiSchema={uiSchema}
                  initialEditMode={true}
                  showEditButton={false}
                  showButtons={false}
                ></JSONEditor>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const RiskFilters = ({ riskSearch, onSearch, filterFormData, setFilterFormData, panelId }) => {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const updateWidth = () => {
      if (ref.current) {
        setWidth(ref.current.offsetWidth);
      }
    };

    const resizeObserver = new ResizeObserver(() => {
      updateWidth();
    });

    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div
      className={`risk-filters ${width > 700 ? 'wide' : ''}`}
      ref={ref}
    >
      <SelectPollingDateRange
        panelId={panelId}
        enableGlobalDates={true}
      />
      <Input
        type="text"
        placeholder="Search..."
        value={riskSearch}
        onChange={onSearch}
      />
      <Filter
        filterFormData={filterFormData}
        setFilterFormData={setFilterFormData}
      />
    </div>
  );
};

export default RiskFilters;
